class FilterFacet extends HTMLElement {
  input;
  checkButton;
  clearButton;

  constructor() {
    super();
    this.input = this.querySelector('input[type=checkbox]');
    this.checkButton = this.querySelector('.check');
    this.clearButton = this.querySelector('.clear');

    this.checkButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.input.checked ^= 1;
      this.closest('form').dispatchEvent(new Event('input'));
    });

    this.clearButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.input.checked = false;
      this.closest('form').dispatchEvent(new Event('input'));
      this.checkButton.focus();
    });

    this.addEventListener('custom:disable', (ev) => {
      this.input.checked = false;
      this.closest('form').dispatchEvent(new Event('input'));
    });
  }
}

customElements.define('filter-facet', FilterFacet);
